import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";
import SearchIcon from "../images/search-icon.png";

const OPTIONS = [
  { label: "All", value: "0" },
  { label: "Contract", value: "1" },
  { label: "Permanent", value: "2" },
  { label: "PRN", value: "3" }
];

const WorkTypeSelect = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const dropdownRef = useRef(null);

  // Default to "0" (All) if value is missing
  const selectedValue = value || "0";

  // Filter options by search
  const filteredOptions = OPTIONS.filter((item) =>
    item.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  // Get label for selected value
  const getLabel = (val) => {
    const found = OPTIONS.find((opt) => opt.value === val);
    return found ? found.label : val;
  };

  return (
    <div className="multi-level-select" ref={dropdownRef}>
      {/* Box */}
      <div className="mls-input-box" onClick={() => setIsOpen(!isOpen)}>
        <span className="mls-placeholder">{getLabel(selectedValue)}</span>
        <FaChevronDown className={`mls-chevron ${isOpen ? "open" : ""}`} />
      </div>

      {/* Dropdown */}
      {isOpen && (
        <div className="mls-dropdown">
          <div className="shift-search-bar">
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <img src={SearchIcon} alt="" />
          </div>
          <ul className="mls-menu-list">
            {filteredOptions.map((item) => (
              <li
                key={item.value}
                className={`mls-menu-item ${
                  selectedValue === item.value ? "selected" : ""
                }`}
                onClick={() => {
                  onChange(item.value);
                  setIsOpen(false);
                }}
              >
                {item.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default WorkTypeSelect;
